import React, { Fragment } from "react";
import find from "lodash/find";
import { TableRow, TableCell } from "@material-ui/core";
import { DPTable, DPErrorMessage, DPComponentLoader } from "Components/DP";
import { useReportHeaderOptions } from "Components/Shared/Reports/useReportHeaderOpions";
import pretty from "Shared/pretty";
import { Header } from "Components/DP/DPTable/DPTable";
import { useBalanceDistributor } from "./useBalanceDistributor";
import { ExternalId } from "generated/graphql";
import useStyles from "./styles";

const ROWS_PER_PAGE = 10;

const BalanceDistributorTableHeaders: Header[] = [
  "Name",
  "User ID",
  "Pay Group",
  "Location",
];

export const BalanceDistributorTable = () => {
  const classes = useStyles();
  const { data, onChangePage, loading, error, page } = useBalanceDistributor();
  const { visibleHeaders, showPayGroupColumn } = useReportHeaderOptions(
    BalanceDistributorTableHeaders
  );

  const findExternalId = (ids: Array<ExternalId>) => {
    return find(ids, {kind: "external_id"})?.id || "";
  };

  if (error) return <DPErrorMessage />;

  return (
    <DPTable
      className={classes.table}
      headers={visibleHeaders}
      rowsPerPage={ROWS_PER_PAGE}
      count={data?.totalCount}
      onChangePage={onChangePage}
      loading={loading}
      page={page}
    >
      <DPComponentLoader
        isLoading={loading}
        kind="table"
        awaitComponent={(
          <>
            {data && data.items.map((item, index) => (
              <TableRow hover key={index}>
                <TableCell>
                  {
                    pretty.fullName(item.employee.firstName || "", item.employee.lastName || "")
                  }
                </TableCell>
                <TableCell>
                  {findExternalId(item.externalIds)}
                </TableCell>
                {
                  showPayGroupColumn && (
                    <TableCell>
                      {item.payGroups.map((payGroup, index) => (
                        <Fragment key={payGroup}>
                          {payGroup}
                          {index !== item.payGroups.length - 1 && <br/>}
                        </Fragment>
                      ))}
                    </TableCell>
                  )
                }
                <TableCell>
                  {item.location}
                </TableCell>
              </TableRow>
            ))}
          </>
        )}
      />
    </DPTable>
  );
};
